import PropTypes from 'prop-types';
import React from 'react';
import { SimpleSnapshotContainer as SnapshotContainer, SnapshotItem } from 'ctm-components';

const CoverDetails = ({ occupancyType, productCategory, suburb, onClick, getHref }) => {
    const startUrl = 'start';

    return (
        <SnapshotContainer title="Cover">
            <SnapshotItem identifier="occupancyType" href={getHref(startUrl)} label={occupancyType} onClick={() => onClick(startUrl)} />
            <SnapshotItem identifier="productCategory" href={getHref(startUrl)} label={productCategory} onClick={() => onClick(startUrl)} />
            {suburb && <SnapshotItem identifier="suburb" href={getHref(startUrl)} label={`Suburb - ${suburb}`} onClick={() => onClick(startUrl)} />}
        </SnapshotContainer>
    );
};

CoverDetails.propTypes = {
    occupancyType: PropTypes.string.isRequired,
    productCategory: PropTypes.string.isRequired,
    suburb: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    getHref: PropTypes.func
};

export { CoverDetails };
